import cs from './cs/index.js';
import csActivity from './cs/activity.js';
import da from './da/index.js';
import daActivity from './da/activity.js';
import de from './de/index.js';
import deActivity from './de/activity.js';
import en from './en/index.js';
import enActivity from './en/activity.js';
import es from './es/index.js';
import esActivity from './es/activity.js';
import fr from './fr/index.js';
import frActivity from './fr/activity.js';
import it from './it/index.js';
import itActivity from './it/activity.js';
import ja from './ja/index.js';
import jaActivity from './ja/activity.js';
import ko from './ko/index.js';
import koActivity from './ko/activity.js';
import pl from './pl/index.js';
import plActivity from './pl/activity.js';
import ptBr from './pt-BR/index.js';
import ptBrActivity from './pt-BR/activity.js';
import ru from './ru/index.js';
import ruActivity from './ru/activity.js';
import sk from './sk/index.js';
import skActivity from './sk/activity.js';
import sv from './sv/index.js';
import svActivity from './sv/activity.js';
import uz from './uz/index.js';
import uzActivity from './uz/activity.js';
import zh from './zh/index.js';
import zhActivity from './zh/activity.js';

const locales = [cs, da, de, en, es, fr, it, ja, ko, pl, ptBr, ru, sk, sv, uz, zh];

const languages = locales.map((locale) => locale.language);

const embeddedLocales = locales.reduce(
  (result, locale) => ({
    ...result,
    [locale.language]: locale.embeddedLocale,
  }),
  {},
);

const activityLocales = {
  cs: csActivity,
  da: daActivity,
  de: deActivity,
  en: enActivity,
  es: esActivity,
  fr: frActivity,
  it: itActivity,
  ja: jaActivity,
  ko: koActivity,
  pl: plActivity,
  'pt-BR': ptBrActivity,
  ru: ruActivity,
  sk: skActivity,
  sv: svActivity,
  uz: uzActivity,
  zh: zhActivity,
};

const flags = locales.map((locale) => locale.flags);

export { activityLocales, locales as default, embeddedLocales, flags, languages };
